import { createClient } from '@supabase/supabase-js'

// Reuses the reright.io Supabase project for Google sign-in. These are baked at
// BUILD time (Vite) — see deploy/web.Dockerfile build args + docker-compose.prod.yml.
const url = import.meta.env.VITE_SUPABASE_URL
const anon = import.meta.env.VITE_SUPABASE_ANON_KEY

export const supabaseConfigured = Boolean(url && anon)

// A tiny stub avoids a hard crash in local/dev builds where the vars aren't set;
// the UI shows a "not configured" note instead of a blank screen.
export const supabase = supabaseConfigured
  ? createClient(url, anon, {
      auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: true },
    })
  : null
